import { DashboardOpenMode } from "MyDashboards/state/types";
import ViewDashboard from "MyDashboards/views/ViewDashboard/ViewDashboard";
import CreateDashboardToolbar from "components/toolbars/CreateDashboardToolbar";
import PageContainer from "design/layouts/PageContainer";
import Page from "design/pages/Page";
import React from "react";

const ViewDashboardsPage = () => {
  return (
    <Page Toolbar={CreateDashboardToolbar} mode={DashboardOpenMode.view}>
      <PageContainer width="100%">
        <ViewDashboard />
      </PageContainer>
    </Page>
  );
};

export default ViewDashboardsPage;
